export default __webpack_public_path__ + "locales/uk-UA/SMTPSettings.json?hash=da7482245e133008342b36a0e6fb4420";